/* daniels-cart-drawer.js
   Slide-out cart drawer matching the existing site design.
   - Opens when cart icon is clicked (instead of navigating to /cart)
   - Shows all cart items with image, title, variant info, qty, price
   - Remove item button (×) on each item
   - Subtotal, View Cart + Checkout buttons at bottom
   - Closes on overlay click or Escape key
*/
(function () {
  'use strict';

  /* ── Create drawer HTML ── */
  var drawerHtml = [
    '<div id="dlCartOverlay"></div>',
    '<div id="dlCartDrawer" aria-label="Cart" role="dialog">',
      '<div id="dlCartHeader">',
        '<span id="dlCartTitle">CART</span>',
        '<button id="dlCartClose" aria-label="Close cart">&#x2715;</button>',
      '</div>',
      '<div id="dlCartItems"></div>',
      '<div id="dlCartFooter">',
        '<div id="dlCartSubtotal">',
          '<span>Subtotal:</span>',
          '<span id="dlCartSubtotalPrice"></span>',
        '</div>',
        '<a id="dlCartViewBtn" href="/cart">VIEW CART</a>',
        '<a id="dlCartCheckoutBtn" href="/checkout">CHECKOUT</a>',
      '</div>',
      '<div id="dlCartEmpty">',
        '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>',
        '<p>Your cart is empty</p>',
        '<a href="/collections/all">Continue Shopping</a>',
      '</div>',
    '</div>'
  ].join('');

  var wrapper = document.createElement('div');
  wrapper.innerHTML = drawerHtml;
  document.body.appendChild(wrapper);

  /* ── Styles ── */
  var style = document.createElement('style');
  style.textContent = [
    /* Overlay */
    '#dlCartOverlay{position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:8998;opacity:0;visibility:hidden;transition:opacity 0.3s,visibility 0.3s;}',
    '#dlCartOverlay.open{opacity:1;visibility:visible;}',

    /* Drawer */
    '#dlCartDrawer{position:fixed;top:0;right:0;bottom:0;width:400px;max-width:95vw;background:#fff;z-index:8999;transform:translateX(100%);transition:transform 0.35s cubic-bezier(0.4,0,0.2,1);display:flex;flex-direction:column;}',
    '#dlCartDrawer.open{transform:translateX(0);}',

    /* Header */
    '#dlCartHeader{display:flex;align-items:center;justify-content:space-between;padding:20px 24px;border-bottom:1px solid #eee;flex-shrink:0;}',
    '#dlCartTitle{font-family:inherit;font-size:14px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#111;}',
    '#dlCartClose{background:none;border:none;font-size:18px;cursor:pointer;color:#111;padding:4px;line-height:1;}',
    '#dlCartClose:hover{opacity:0.6;}',

    /* Items */
    '#dlCartItems{flex:1;overflow-y:auto;padding:16px 24px;}',
    '.dlCart-item{display:grid;grid-template-columns:80px 1fr auto;gap:12px;padding:16px 0;border-bottom:1px solid #f0f0f0;}',
    '.dlCart-item:last-child{border-bottom:none;}',
    '.dlCart-item-img{width:80px;height:80px;object-fit:cover;background:#f5f5f5;display:block;}',
    '.dlCart-item-info{display:flex;flex-direction:column;gap:4px;}',
    '.dlCart-item-title{font-size:14px;font-weight:500;color:#111;line-height:1.3;text-decoration:none;}',
    '.dlCart-item-title:hover{opacity:0.7;}',
    '.dlCart-item-variant{font-size:12px;color:#888;}',
    '.dlCart-item-price{font-size:13px;font-weight:600;color:#111;}',
    '.dlCart-item-qty{display:flex;align-items:center;gap:6px;margin-top:6px;}',
    '.dlCart-qty-btn{width:26px;height:26px;border:1px solid #ddd;background:#fff;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#111;transition:all 0.15s;}',
    '.dlCart-qty-btn:hover{border-color:#111;}',
    '.dlCart-qty-num{font-size:13px;font-weight:600;min-width:20px;text-align:center;}',
    '.dlCart-item-remove{background:none;border:none;cursor:pointer;color:#bbb;font-size:18px;padding:4px;line-height:1;align-self:flex-start;transition:color 0.15s;}',
    '.dlCart-item-remove:hover{color:#111;}',

    /* Empty */
    '#dlCartEmpty{display:none;flex-direction:column;align-items:center;justify-content:center;flex:1;gap:12px;padding:40px 24px;text-align:center;}',
    '#dlCartEmpty.show{display:flex;}',
    '#dlCartEmpty p{font-size:14px;color:#888;margin:0;}',
    '#dlCartEmpty a{font-size:12px;font-weight:600;letter-spacing:1px;text-transform:uppercase;color:#111;text-decoration:underline;text-underline-offset:3px;}',

    /* Footer */
    '#dlCartFooter{border-top:1px solid #eee;padding:16px 24px;flex-shrink:0;display:flex;flex-direction:column;gap:10px;}',
    '#dlCartSubtotal{display:flex;justify-content:space-between;align-items:center;font-size:14px;font-weight:600;color:#111;letter-spacing:0.5px;text-transform:uppercase;}',
    '#dlCartSubtotalPrice{font-size:16px;}',
    '#dlCartViewBtn,#dlCartCheckoutBtn{display:block;width:100%;padding:14px;text-align:center;font-size:12px;font-weight:700;letter-spacing:2px;text-transform:uppercase;text-decoration:none;transition:all 0.2s;}',
    '#dlCartViewBtn{background:#fff;color:#111;border:2px solid #111;}',
    '#dlCartViewBtn:hover{background:#111;color:#fff;}',
    '#dlCartCheckoutBtn{background:#111;color:#fff;border:2px solid #111;}',
    '#dlCartCheckoutBtn:hover{background:#fff;color:#111;}',
  ].join('');
  document.head.appendChild(style);

  /* ── DOM refs ── */
  var overlay      = document.getElementById('dlCartOverlay');
  var drawer       = document.getElementById('dlCartDrawer');
  var closeBtn     = document.getElementById('dlCartClose');
  var itemsEl      = document.getElementById('dlCartItems');
  var emptyEl      = document.getElementById('dlCartEmpty');
  var footerEl     = document.getElementById('dlCartFooter');
  var subtotalEl   = document.getElementById('dlCartSubtotalPrice');

  /* ── Open / Close ── */
  function openCart() {
    fetchCart();
    overlay.classList.add('open');
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeCart);
  overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeCart();
  });

  /* ── Money format ── */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── Render cart ── */
  function renderCart(cart) {
    itemsEl.innerHTML = '';
    var items = cart.items || [];

    if (items.length === 0) {
      emptyEl.classList.add('show');
      footerEl.style.display = 'none';
      return;
    }

    emptyEl.classList.remove('show');
    footerEl.style.display = '';

    items.forEach(function (item) {
      var el = document.createElement('div');
      el.className = 'dlCart-item';

      // Build variant string
      var variants = [];
      if (item.variant_title && item.variant_title !== 'Default Title') {
        // Split by / to get individual options
        item.variant_title.split(' / ').forEach(function(v) {
          variants.push(v.trim());
        });
      }
      // Also check properties
      var props = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function(key) {
          if (item.properties[key]) {
            props += '<br>' + key + ': ' + item.properties[key];
          }
        });
      }

      var variantHtml = variants.length > 0 ? variants.join(' / ') : '';

      el.innerHTML = [
        '<a href="' + item.url + '">',
          '<img class="dlCart-item-img" src="' + (item.image || '') + '" alt="' + (item.product_title || '') + '">',
        '</a>',
        '<div class="dlCart-item-info">',
          '<a class="dlCart-item-title" href="' + item.url + '">' + item.product_title + '</a>',
          variantHtml ? '<div class="dlCart-item-variant">' + variantHtml + props + '</div>' : '',
          '<div class="dlCart-item-price">' + money(item.final_line_price) + '</div>',
          '<div class="dlCart-item-qty">',
            '<button class="dlCart-qty-btn" data-key="' + item.key + '" data-action="minus">−</button>',
            '<span class="dlCart-qty-num">' + item.quantity + '</span>',
            '<button class="dlCart-qty-btn" data-key="' + item.key + '" data-action="plus">+</button>',
          '</div>',
        '</div>',
        '<button class="dlCart-item-remove" data-key="' + item.key + '" aria-label="Remove">&#x2715;</button>'
      ].join('');

      itemsEl.appendChild(el);
    });

    subtotalEl.textContent = money(cart.total_price);

    // Bind qty and remove buttons
    itemsEl.querySelectorAll('.dlCart-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.dataset.key;
        var action = this.dataset.action;
        var qtyEl = this.parentElement.querySelector('.dlCart-qty-num');
        var currentQty = parseInt(qtyEl.textContent);
        var newQty = action === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);
        updateItem(key, newQty);
      });
    });

    itemsEl.querySelectorAll('.dlCart-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateItem(this.dataset.key, 0);
      });
    });
  }

  /* ── Fetch cart ── */
  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function () {
        itemsEl.innerHTML = '<p style="padding:20px;color:#888;text-align:center;">Could not load cart.</p>';
      });
  }

  /* ── Update item qty ── */
  function updateItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        updateCartCount(cart.item_count);
      });
  }

  /* ── Update header cart count ── */
  function updateCartCount(count) {
    var el = document.getElementById('cart-count');
    if (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  /* ── Intercept cart icon click ── */
  function bindCartIcon() {
    var cartIcon = document.getElementById('cart-icon-btn');
    if (cartIcon && !cartIcon._dlCartBound) {
      cartIcon._dlCartBound = true;
      cartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openCart();
      });
    }
  }

  bindCartIcon();

  /* ── Listen for cart updates from quick view / other sources ── */
  document.addEventListener('cart:updated', function (e) {
    var count = e.detail && e.detail.cart ? e.detail.cart.item_count : 0;
    updateCartCount(count);
    if (drawer.classList.contains('open')) {
      fetchCart();
    }
  });

  // Re-fetch after quick view adds to cart
  var origFetch = window.fetch;
  window.fetch = function (url, opts) {
    var result = origFetch.apply(this, arguments);
    if (typeof url === 'string' && url.includes('/cart/add')) {
      result.then(function () {
        setTimeout(function () {
          fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
            updateCartCount(cart.item_count);
            if (drawer.classList.contains('open')) renderCart(cart);
          });
        }, 300);
      });
    }
    return result;
  };

  // Expose globally
  window.dlOpenCart = openCart;
  window.dlCloseCart = closeCart;
  window.dlFetchCart = fetchCart;

})();